export const getGigondasData = () => ({
  name: "Gigondas",
  region: "Rhône",
  country: "France",
  description: "Gigondas est une appellation prestigieuse du Rhône méridional, produisant des vins rouges puissants et structurés dans un amphithéâtre naturel au pied des Dentelles de Montmirail.",
  type: "subregion",
  area: "1,200 ha",
  production: "40,000 hectolitres",
  mapAreas: [
    { region: "Gigondas", x: 51, y: 67, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat méditerranéen chaud et sec",
    soil: "Sols de calcaire, argile et galets roulés",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des notes de fruits mûrs et d'épices",
    rose: "Rosés fruités et équilibrés, avec une belle structure"
  },
  history: "Gigondas produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1971. Le vignoble est planté dans un amphithéâtre naturel au pied des Dentelles de Montmirail.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine provençale",
  grapeVarieties: [
    {
      name: "Grenache",
      percentage: "65%",
      description: "Cépage principal de Gigondas, produisant des vins puissants et fruités",
      characteristics: "Puissant, fruité, alcool élevé, notes de fruits rouges mûrs",
      wineStyles: "Sec, plein-corps, fruité"
    },
    {
      name: "Syrah",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant structure et couleur",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Mourvèdre",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant complexité et capacité de garde",
      characteristics: "Complexe, tannique, notes d'épices et de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Cinsault",
      percentage: "5%",
      description: "Cépage d'assemblage, apportant élégance et fruité",
      characteristics: "Élégant, fruité, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    }
  ]
}); 